/**
 * Kategori listeleme sayfaları: API açıklaması veya şablon tabanlı SEO gövde metni.
 */

export function truncateMetaDescription(s, max = 158) {
  if (!s) return '';
  const x = s.trim();
  if (x.length <= max) return x;
  return `${x.slice(0, max - 1).trim()}…`;
}

export function stripHtmlForSeoText(html) {
  if (!html) return '';
  return String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * @param {object|null} category — API categories kaydı (name, slug, description)
 * @param {function} t — i18n t
 */
export function getCategoryIntroText(category, t) {
  const fromApi = stripHtmlForSeoText(category?.description);
  if (fromApi.length >= 50) {
    return fromApi;
  }
  const name = category?.name || '';
  return t(
    'seo.categoryIntroTemplate',
    '{{name}} ürünlerinde çeşitli seçenekler, güncel fiyatlar ve güvenli alışveriş için Turkish E-Market’i kullanın. Filtre ve sıralama ile size uygun ürünü hızlıca bulun.',
    { name: name || t('nav.products') },
  );
}

export function buildListingMetaTitle({
  t,
  mode,
  categoryName,
  page,
  searchQuery,
}) {
  const pageSuffix = page > 1 ? ` – ${t('seo.pageN', 'Sayfa')} ${page}` : '';

  if (mode === 'search' && searchQuery) {
    return `${t('seo.metaTitleSearchPrefix', 'Arama')}: "${searchQuery}"${pageSuffix} | Turkish E-Market`;
  }
  if (mode === 'featured') {
    return `${t('seo.metaTitleFeatured', 'Günün fırsatları ve öne çıkan ürünler')}${pageSuffix} | Turkish E-Market`;
  }
  if (mode === 'category' && categoryName) {
    return `${categoryName} ${t('seo.metaTitleCategorySuffix', 'ürünleri ve fiyatları')}${pageSuffix} | Turkish E-Market`;
  }
  return `${t('seo.metaTitleAllProducts', 'Tüm ürünler ve kategoriler')}${pageSuffix} | Turkish E-Market`;
}

export function buildListingMetaDescription({
  t,
  mode,
  categoryName,
  totalProducts,
  page,
}) {
  const pageNote = page > 1 ? ` ${t('seo.pageN', 'Sayfa')} ${page}.` : '';
  if (mode === 'search') {
    return t(
      'seo.metaDescSearch',
      'Arama sonuçları Turkish E-Market’te. Filtreleyin, karşılaştırın ve güvenle satın alın.',
    );
  }
  if (mode === 'featured') {
    return t(
      'seo.metaDescFeatured',
      'Öne çıkan ürünler, kampanyalar ve güncel fiyatlar Turkish E-Market’te.',
    );
  }
  if (mode === 'category' && categoryName) {
    return `${categoryName}: ${totalProducts || ''} ${t('seo.metaDescCategoryBody', 'ürün, hızlı teslimat ve güvenli ödeme seçenekleri.')}${pageNote}`;
  }
  return t(
    'seo.metaDescAllProducts',
    'Turkish E-Market’te binlerce ürün, kategori filtreleri ve anlaşılır fiyatlarla alışveriş yapın.',
  );
}
